import frUtils from '../../util/frUtils';
(function ($) {
  $.fn.workstreaminfo = function () {
    this.each((i, el) => {
      const $self = $(el);

      if ($('body').find('.main-left-content').length < 1) {
        $('.workstream-content-body .page-content-container').css({
          width: '100%',
          'margin-left': '0',
        });
      }

      const $commentBtn = $self.find('.main-sidebar .form-block button');
      const $formContainer = $self.find('.form-container');
      let ajaxConfig = JSON.parse($formContainer.attr('ajax-config'));
      const $closeIcon = $formContainer.find(
        '.wFormContainer .container-detail .wForm form a'
      );
      const $form = $formContainer.find(
        '.wFormContainer .container-detail .wForm form'
      );
      const $err1 = $form.find('.errMsg1');
      const $err2 = $form.find('.errMsg2');
      const $err3 = $form.find('.errMsg3');
      const $err4 = $form.find('.errMsg4');
      const $input1 = $form.find('.2790');
      const $input2 = $form.find('.2792');
      const $input3 = $form.find('.2671');
      const $input4 = $form.find('.2793');
      const $successAlert = $form.find('.success-alert');
      const $wrongAlert = $form.find('.wrong-alert');
      const $failAlert = $form.find('.fail-alert');
      const $submitBtn = $form.find('.primaryAction');
      const $ajaxLoading = $self.find('.ajax-loading');

      let ajaxRunning = false;

      function validateForm(input) {
        var x = input[0].value;
        if (x == '') {
          return false;
        } else {
          return true;
        }
      }

      function validateEmail(email) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      $commentBtn.on('click', () => {
        frUtils.setUrlHash('getinvolved');
        $formContainer.toggle();
      });

      $closeIcon.on('click', (event) => {
        event.preventDefault();
        $formContainer.toggle();
        frUtils.removeUrlHash();
      });

      $submitBtn.on('click', (e) => {
        $successAlert.css('display', 'none');
        $failAlert.css('display', 'none');
        $wrongAlert.css('display', 'none');
        e.preventDefault();
        let $valid1 = validateForm($input1);
        let $valid2 = validateForm($input2);
        let $valid3 = validateForm($input3);
        let $valid5 = validateForm($input4);
        let $valid4 = validateEmail($input3[0].value);
        if (!$valid1) {
          $err1.css('display', '');
          $input1.css('border-color', '#D17466');
        } else {
          $err1.css('display', 'none');
          $input1.css('border-color', '#bbb');
        }
        if (!$valid2) {
          $err2.css('display', '');
          $input2.css('border-color', '#D17466');
        } else {
          $err2.css('display', 'none');
          $input2.css('border-color', '#bbb');
        }
        if ($valid3 && $valid4) {
          $err3.css('display', 'none');
          $input3.css('border-color', '#bbb');
        } else {
          $err3.css('display', '');
          $input3.css('border-color', '#D17466');
        }
        if (!$valid5) {
          $err4.css('display', '');
          $input4.css('border-color', '#D17466');
        } else {
          $err4.css('display', 'none');
          $input4.css('border-color', '#bbb');
        }
        if (!$valid1 || !$valid2 || !$valid3 || !$valid4 || !$valid5) {
          $wrongAlert.css('display', 'flex');
          return;
        }
        $wrongAlert.css('display', 'none');
        var data1 = $form.serialize();

        ajaxConfig['callurl'] = 'https://www.tfaforms.com/responses/processor';
        ajaxConfig['data1'] = data1;
        postComment(ajaxConfig);
      });

      const postComment = (ajaxConfig) => {
        if (ajaxRunning) return;

        //Start
        ajaxRunning = true;

        $ajaxLoading.addClass('wrap-loading');
        $ajaxLoading.css('display', '');
        $submitBtn.css('display', 'none');
        doAjax(ajaxConfig, (response) => {
          console.log(
            '-------------- Response from server -----------',
            response
          );

          $ajaxLoading.removeClass('wrap-loading');
          $ajaxLoading.css('display', 'none');
          $submitBtn.css('display', '');
          if (response.data.success1) {
            $successAlert.css('display', 'flex');
            $failAlert.css('display', 'none');
          } else {
            $successAlert.css('display', 'none');
            $failAlert.css('display', 'flex');
          }
          // $formContainer.toggle();

          ajaxRunning = false;
        });
      };

      const doAjax = (config, callback) => {
        let response = { sucess: false, data: [] };
        let configObject = {
          action: config.action,
          callurl: config.callurl,
          // data: config.data1,
        };

        let configString = Object.keys(configObject)
          .map((key) => key + '=' + configObject[key])
          .join('&');
        let t_data = config.data1;
        let urlWithParameters = config.url + '?' + configString + '&' + t_data;

        window
          .fetch(urlWithParameters, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
            },
            // body: JSON.stringify(config.data1),
          })
          .then((resp) => resp.json())
          .then((data) => {
            if (data.success) {
              response.data = data.data;
              response.success = data.success;
            }
            callback(response);
          })
          .catch(function (err) {
            console.log(
              'There was an error processing your search, please try again later.',
              err
            );
          });
      };

      // Function to open modal on load
      const openModalOnLoading = () => {
          const $commentBtn = $self.find('.main-sidebar .form-block button');           
          if (frUtils.urlHashValue == 'getinvolved') {
              $($commentBtn).trigger('click');                    
          }
      }
      openModalOnLoading();

    });
    return this;
  };

  $(() => {
    $('.workstream-content-body').workstreaminfo();
  });
})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/workstream-info.js